import { Globals } from "@coreapp/CoreApp/Globals";
import { ListItemOption } from "@theorgchartdev/storybook/dist/components/List/ListItem";
import { appstr } from "@coreapp/utils/appstr";

class LevelHandler {
  static AllLevels = -1;
  static FirstLevel = 1;

  static getLevelString(level: number): string {
    if (!Globals._stringMgr) return level.toString();
    if (level === LevelHandler.AllLevels) return appstr("alllevels");

    return `${level}  ${level === LevelHandler.FirstLevel ? appstr("Level") : appstr("Levels")}`;
  }

  static toOptions(level: number, handler: (level: any) => void): ListItemOption {
    return {
      label: LevelHandler.getLevelString(level),
      value: level,
      clickHandler: handler
    };
  }

  static buildLevelOptions(onLevelChange: (level: any) => void): ListItemOption[] {
    let levelOptions = [];
    levelOptions.push(LevelHandler.toOptions(LevelHandler.AllLevels, onLevelChange));

    for (let i = 2; i < 11; i++) {
      levelOptions.push(LevelHandler.toOptions(i, onLevelChange));
    }
    return levelOptions;
  }
}

export default LevelHandler;
